import React from 'react';
export function BioPrintView() {
  return <div id="bio-print-view" aria-hidden="true" data-id="element-7">
      <div className="bio-print-page" data-id="element-8">
        {/* Header */}
        <header className="bio-print-header" data-id="element-9">
          <h1 className="bio-print-name" data-id="element-10">Michael K. Bigos Jr.</h1>
          <p className="bio-print-title" data-id="element-11">
            Senior Director | Product, Experience & Brand Systems
          </p>
          <p className="bio-print-subtitle" data-id="element-12">
            Executive Biography | Brand Strategy & UX/Product Leadership
          </p>
          <div className="bio-print-contact" data-id="element-13">
            <span data-id="element-14">mkbigosjr@gmail.com</span>
            <span className="bio-print-dot" data-id="element-15">·</span>
            <a href="https://www.linkedin.com/in/michaelkbigosjr/" data-id="element-16">
              linkedin.com/in/michaelkbigosjr
            </a>
            <span className="bio-print-dot" data-id="element-17">·</span>
            <span data-id="element-18">Tampa, Florida · Open to Remote</span>
          </div>
          <div className="bio-print-rule" data-id="element-19" />
        </header>

        {/* Intro */}
        <section className="bio-print-section" data-id="element-20">
          <p className="bio-print-intro" data-id="element-21">
            Michael K. Bigos Jr. is a seasoned brand strategist, UX/product
            design leader, and creative visionary with over 20 years of
            experience delivering transformative enterprise and consumer-facing
            solutions. A U.S. Army veteran, Michael combines mission-driven
            discipline with human-centered design thinking, empowering
            organizations to turn complex challenges into clear, scalable,
            high-impact experiences.
          </p>
        </section>

        {/* Strategic & Creative Leadership */}
        <section className="bio-print-section" data-id="element-22">
          <h2 className="bio-print-h2" data-id="element-23">Strategic & Creative Leadership</h2>
          <p data-id="element-24">
            Michael brings a rare combination of strategic leadership and
            hands-on design expertise to enterprise-scale initiatives. He has
            led end-to-end product lifecycles from 0→1 discovery through design
            system implementation, scalable delivery, and measurable business
            impact. His work spans cross-platform UX/UI, omni-channel customer
            journeys, and enterprise design systems such as IBM Carbon and
            Material UI.
          </p>
        </section>

        {/* Design & Product Expertise */}
        <section className="bio-print-section" data-id="element-25">
          <h2 className="bio-print-h2" data-id="element-26">Design & Product Expertise</h2>
          <ul className="bio-print-list" data-id="element-27">
            <li data-id="element-28">
              <strong data-id="element-29">Systems & Tools:</strong> Adobe Creative Cloud, Figma,
              AI-driven design workflows (GAI, MLAI), Jira, Azure DevOps, Wrike,
              Asana
            </li>
            <li data-id="element-30">
              <strong data-id="element-31">Compliance & Accessibility:</strong> Section 508, WCAG 2.1
              AA, ADA standards
            </li>
            <li data-id="element-32">
              <strong data-id="element-33">Scalable Systems:</strong> Reusable components,
              interaction patterns, design system governance
            </li>
            <li data-id="element-34">
              <strong data-id="element-35">Omni-Channel Impact:</strong> Web, mobile, eCommerce,
              fintech, D2C/B2C/B2B, government initiatives
            </li>
          </ul>
          <p data-id="element-36">
            Michael translates complex workflows into intuitive, engaging, and
            accessible experiences. He bridges research, strategy, and
            execution, ensuring user-centered outcomes aligned with business
            objectives. His approach balances systems thinking, data-informed
            decisions, and creative intuition to elevate adoption, engagement,
            and operational efficiency.
          </p>
        </section>

        {/* Brand & Marketing Leadership */}
        <section className="bio-print-section" data-id="element-37">
          <h2 className="bio-print-h2" data-id="element-38">Brand & Marketing Leadership</h2>
          <p data-id="element-39">
            Michael has held leadership roles as Brand Manager, Art/Creative
            Director, and Marketing Manager for organizations ranging from
            startups to Fortune 500 companies — including Walmart, Pedigree,
            Samsung, Neato, and Hoover. He has:
          </p>
          <ul className="bio-print-list" data-id="element-40">
            <li data-id="element-41">
              Developed enterprise-wide branding initiatives and messaging
              strategies
            </li>
            <li data-id="element-42">Designed and maintained global brand identity systems</li>
            <li data-id="element-43">
              Partnered with cross-functional teams to align stakeholders and
              scale high-quality outputs
            </li>
            <li data-id="element-44">
              Guided early-stage founders in establishing market presence and
              facilitated enterprise digital transformation
            </li>
          </ul>
        </section>

        {/* Cross-Industry Impact */}
        <section className="bio-print-section" data-id="element-45">
          <h2 className="bio-print-h2" data-id="element-46">Cross-Industry Impact</h2>
          <p data-id="element-47">
            Michael's career spans Executive Government, DoD, B2B/B2C, SaaS,
            eCommerce, retail, finance, construction, oil & gas, and IT
            environments. He excels at:
          </p>
          <ul className="bio-print-list" data-id="element-48">
            <li data-id="element-49">Building and modernizing complex digital infrastructures</li>
            <li data-id="element-50">Elevating and mentoring multi-disciplinary teams</li>
            <li data-id="element-51">Optimizing acquisition, service, and product journeys</li>
            <li data-id="element-52">
              Aligning business objectives with design strategy for measurable
              results
            </li>
          </ul>
        </section>

        {/* Vision & Philosophy */}
        <section className="bio-print-section" data-id="element-53">
          <h2 className="bio-print-h2" data-id="element-54">Vision & Philosophy</h2>
          <p data-id="element-55">
            Guided by faith, service, and a passion for design, Michael is
            committed to empowering entrepreneurs, organizations, and teams to
            articulate their vision and execute with clarity. He thrives in
            senior leadership roles where strategy, craft, and execution
            converge, delivering meaningful experiences that resonate with users
            and elevate brands.
          </p>
        </section>

        {/* Testimonials */}
        <section className="bio-print-section" data-id="element-56">
          <h2 className="bio-print-h2" data-id="element-57">Testimonials</h2>
          <blockquote className="bio-print-quote" data-id="element-58">
            "Mike is a Pegasus! One of the most talented professionals I've ever
            worked with. His artistry, leadership, and ability to bring cohesion
            to chaotic situations set him apart."
          </blockquote>
          <blockquote className="bio-print-quote" data-id="element-59">
            "He translates complex business problems into scalable, high-impact
            products, aligning stakeholders around a shared vision that delivers
            measurable outcomes."
          </blockquote>
          <blockquote className="bio-print-quote" data-id="element-60">
            "Michael's work emphasizes not just aesthetics but building trust,
            loyalty, and momentum for lasting impact."
          </blockquote>
        </section>

        {/* Footer */}
        <footer className="bio-print-footer" data-id="element-61">
          <div className="bio-print-rule" data-id="element-62" />
          <div className="bio-print-footer-links" data-id="element-63">
            <span data-id="element-64">mkbigosjr@gmail.com</span>
            <span className="bio-print-dot" data-id="element-65">·</span>
            <span data-id="element-66">linkedin.com/in/michaelkbigosjr</span>
            <span className="bio-print-dot" data-id="element-67">·</span>
            <span data-id="element-68">Tampa, Florida · Open to Remote</span>
          </div>
          <p className="bio-print-footer-note" data-id="element-69">
            Section 508 · WCAG AA · ADA Compliant · Federal & Enterprise ·
            AI/GAI Integration
          </p>
        </footer>
      </div>
    </div>;
}